import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box'; 
  

const Authentication_Date = async (parms) => {
     const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/uidai/Auth_Suc_Int`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch distribution data');
  }
  return response.json();
};


const Auth_Suc_Dist = ({ month, year }) => {

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null); 
  const monthcardstab = useRef(null); 
    
  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await Authentication_Date({ month, year});
        setTabHeading(response_data.heading);

        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data);

        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year]);

 
  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && monthcardstab.current) {
      monthcardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  
 if (reportData.length === 0) {
    return <div className="mainhead" align="center" > No data found </div>;
  }
  
    const totals= reportData.reduce(
      (acc, item)=>{
        acc.total += item.total || 0;
        acc.total_success +=item.total_success||0;
        acc.sucessPercentage +=item.sucessPercentage||0

         return acc;
      },
        {
          total :0,
          total_success:0,
          sucessPercentage:0
        }
    )
      
  return (
    
    <> 
    <br/>    <br/>

    <div align="right"><a
				href={"https://epos.jk.gov.in/Auth_Success.jsp?month="+month+"&year="+ year +"&exportToExcel=YES"}
				style={{fontSize: '15px', fontWeight: 'bold', color: 'blue'}}>FPS Wise Excel Download</a></div><br/>
       <table  align="center" width="65%" border={1}  >
        <thead>
        <tr className="tableheader">
                        <th colSpan={14}>{tabHeading}</th>
                    </tr>
    
<tr class="tableheader">
				<th rowspan="1"><div align="center">Sl.No</div></th>
				<th rowspan="1"><div align="center">District</div></th>
				<th rowSpan="1"><div align="center">Total<br/>Authentication</div></th>
				<th rowSpan="1"><div align="center">Success<br/>Authentications</div></th>
				<th rowSpan="1"><div align="center">Success %</div></th>
			</tr>
			
        </thead>
        <tbody>
          {reportData.map((item, index) => (
            <tr key={item.dist_name}>
              <td style={{ textAlign: 'center' }}>{  index + 1 }</td> 
              <td style={{ textAlign: 'left' }}>{item.dist_name} </td>
              <td style={{ textAlign: 'right' }}>{item.total}</td>
              <td style={{ textAlign: 'right' }}>{item.total_success}</td>
              <td style={{ textAlign: 'right' }}>{item.sucessPercentage}</td>
      
            </tr>
 ))}

<tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_success}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.total_success *100/totals.total) .toFixed(2)}</td>
          </tr>
          <tr>
            <td class="styleDate" colSpan={5} style={{ textAlign: 'right',align:"Right"}} >Date Refresh Time : {reportData[0].data_time.substring(0, 19)}</td>
          </tr>
        </tbody>
      </table>
     
      <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
   </div>
    </>
  );   
};

export default Auth_Suc_Dist;


